import React from "react";
import Alert from "react-bootstrap/Alert";

/* const variant = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
  "dark",
]; */

export const BootstrapAlert = ({ variant = "primary", message }) => {
  return (
    <>
      {message && (
        <Alert key={variant} variant={variant}>
          {message}
        </Alert>
      )}
    </>
  );
};
